(function () {
  function modifyVpProducts() {
    const vpTables = document.querySelectorAll('.bss-b2b-cart-item-qty-table');

    vpTables.forEach((vpTable) => {
      const card = vpTable.closest('[bss-b2b-product-qb-id], product-card, .product-card__content');
      if (!card || card.dataset.vpProcessed === "true") return;

      vpTable.style.display = 'none';

      const rows = vpTable.querySelectorAll('tbody tr.bss-b2b-qty-table-row');
      if (rows.length === 0) return;

      const priceCell = rows[rows.length - 1].querySelectorAll('td')[1];
      if (!priceCell) return;

      const finalPrice = priceCell.textContent.trim().replace(/\s*each/i, "").trim();
      const priceContainer = card.querySelector('product-price, .product-price');
      if (!priceContainer) return;

      const regularPriceEl = priceContainer.querySelector('.price__regular .price, .price');
      const salePriceEl = priceContainer.querySelector('.price-item--sale.price');
      const comparePriceEl = priceContainer.querySelector('.compare-at-price, .price-item--regular');

      if (comparePriceEl && comparePriceEl !== regularPriceEl) {
        comparePriceEl.style.display = 'none';
      }

      const newPriceHtml = `<span style="font-weight: normal; font-size: 1em;">Starting at</span> ${finalPrice}`;

      if (regularPriceEl) regularPriceEl.innerHTML = newPriceHtml;
      if (salePriceEl) salePriceEl.innerHTML = newPriceHtml;

      card.dataset.vpProcessed = "true";
    });
  }

  setTimeout(modifyVpProducts, 500);
  setTimeout(modifyVpProducts, 1200);
  setTimeout(modifyVpProducts, 2500);

  let timeoutId;
  const observer = new MutationObserver((mutations) => {
    const hasNewNodes = mutations.some(m => m.addedNodes.length > 0);
    if (hasNewNodes) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(modifyVpProducts, 50);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
